import { render, staticRenderFns } from "./cartTrapezSOL.vue?vue&type=template&id=b27dd45c&"
import script from "./cartTrapezSOL.vue?vue&type=script&lang=js&"
export * from "./cartTrapezSOL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports